<h1 class="title-modal-historic" mat-dialog-title>
  <strong>Historic of this function </strong>
  <mat-icon style="cursor: pointer" (click)="onNoClick()">close</mat-icon>
</h1>
<div class="historique-container" micScrollBar>
  @if (this.dataSource.data.length === 0) {
  <mic-spinner color="accent" [strokeWidth]="5"></mic-spinner>
  } @else {
  <mic-table [config]="tableConfig" [dataSource]="dataSource">
    <ng-container *micCellTemplate="let item; name: 'status'">
      <mat-icon [class]="item.status">{{ utilService.getTableRowStatusIcon(item.status) }}</mat-icon>
    </ng-container>
    <ng-container *micRowDetail="let item">
      <p>display the details</p>
    </ng-container>
  </mic-table>
  }
</div>
